import React, { useRef, useEffect } from 'react';

import "./ModalContentWrapper.scss";

const ModalContentWrapper = (props) =>
{
    const refContainer = useRef(null);

    useEffect(() => {
        refContainer.current.scrollTop = 0;
    }, []);

    const isScrollBottomHandlerRequired = () =>
    {
        return props.onScrollBottomReached !== undefined ;
    }

    const handleScroll = (e) =>
    {
        const diff = parseInt((+e.target.scrollHeight - +e.target.scrollTop),10) ;

        const bottom = ( +diff + 1 === e.target.clientHeight || +diff === e.target.clientHeight );

        if ( bottom && props.onScrollBottomReached !== undefined )
        {
            props.onScrollBottomReached();
        }
    }

    const handler = isScrollBottomHandlerRequired() ? handleScroll : null ;

    const style = props.width !== undefined ? { width: props.width } : {} ;

    if ( props.columns === 2 )
    {
        return (
            <div ref={refContainer} className="s360-modal-content" onScroll={handler}>
                <div className='modal-two-column' style={style}>
                    { props.children }
                </div>
            </div>
        )
    }
    else
    {
    return (
        <div ref={refContainer} className="s360-modal-content" onScroll={handler}>
            <div className='modal-one-column' style={style}>
                { props.children }
            </div>
        </div>
    )
}
}

export default ModalContentWrapper ;